<template>
  <div class="powerbi-report-page">
    <iframe 
      width="100%" 
      height="600" 
      :src="powerbiurl" 
      frameborder="0" 
      allowFullScreen="true"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  data(){
    return{
      powerbiurl: '',
      brandid: this.$route.params.Id
    }
  },

  mounted(){
    let that = this
    let pkglist = JSON.parse(localStorage.getItem("price")).val
    let currentpkg = pkglist.find(o => o.subid/1 === that.brandid/1)
    that.powerbiurl = currentpkg.url
    // this.powerbiurl = JSON.parse(window.localStorage.getItem('pbiurl')).val
  }
}
</script>